import { Site } from 'hooks/useOutletSite/useOutletSite.types';

export const findSite = (
  array: Site[] | undefined,
  siteId: string | undefined,
) => {
  if (!array || !array.length) {
    return;
  }
  return array.find((site: Site) => site.id === siteId);
};
